import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const DeleteModal = ({ show, handleClose, handleConfirm, message, itemName }) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header className="border-bottom bg-light d-flex justify-content-between align-items-center">
                <Modal.Title className="text-dark font-weight-bold">
                    Confirm Delete: <span className="text-danger">"{itemName}"</span>
                </Modal.Title>
                <button
                    type="button"
                    className="close btn btn-sm btn-outline-secondary ml-2"
                    aria-label="Close"
                    onClick={handleClose}
                >
                    &times;
                </button>
            </Modal.Header>

            <Modal.Body>
                <p className="text-primary mb-0">
                    {message || "Are you sure you want to delete this item? This action cannot be undone."}
                </p>
            </Modal.Body>

            <Modal.Footer className="justify-content-between">
                <Button variant="outline-secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="outline-danger" onClick={handleConfirm}>
                    <i className="fa fa-trash mr-2"></i> Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteModal;
